<template>
  <section class="ap-stats">

    <!-- Row 1: Tax + Cosec (2 equal columns) -->
    <div class="ap-stats-row ap-stats-row--primary">
      <div class="ap-stat ap-stat--link ap-stat-tax" @click="$router.push({ name: 'Admin-Task-Tax', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">Tax</span>
          <span class="ap-stat-icon ap-si-tax"><fa-icon :icon="['fas', 'file-invoice']" /></span>
        </div>
        <div class="ap-stat-value">{{ tax }}</div>
        <div class="ap-stat-foot">
          pending tasks <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;" />
        </div>
      </div>

      <div class="ap-stat ap-stat--link ap-stat-cosec" @click="$router.push({ name: 'Admin-Task-Cosec', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">Cosec and Business Support</span>
          <span class="ap-stat-icon ap-si-cosec"><fa-icon :icon="['fas', 'stamp']" /></span>
        </div>
        <div class="ap-stat-value">{{ cosecAndBusinessSupport }}</div>
        <div class="ap-stat-foot">
          pending tasks <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;" />
        </div>
      </div>
    </div>

    <!-- Row 2: all other cards fit in one row -->
    <div class="ap-stats-row ap-stats-row--secondary">
      <div class="ap-stat ap-stat--link" @click="$router.push({ name: 'Admin-Email-Blast', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">Email Blast</span>
          <span class="ap-stat-icon ap-si-email"><fa-icon :icon="['fas', 'paper-plane']" /></span>
        </div>
        <div class="class ap-stat-wrapper">
          <div class="ap-stat-value ap-stat-value--icon">
            <fa-icon :icon="['fas', 'envelope-open-text']" />
          </div>
          <div class="ap-stat-foot">
            <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;opacity:0.4;font-size:10px" />
          </div>
        </div>
      </div>

      <div class="ap-stat ap-stat--link" @click="$router.push({ name: 'Admin-Task-Incorporation', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">Incorporation</span>
          <span class="ap-stat-icon ap-si-incorporation"><fa-icon :icon="['fas', 'gavel']" /></span>
        </div>
        <div class="ap-stat-wrapper">
          <div class="ap-stat-value">{{ incorporation }}</div>
          <div class="ap-stat-value-label">pending tasks</div>
          <div class="ap-stat-foot">
            <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;opacity:0.4;font-size:10px" />
          </div>
        </div>
      </div>

      <div v-if="isSuperAdmin" class="ap-stat ap-stat--link" @click="$router.push({ name: 'Admin-Task-Billing', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">Billing</span>
          <span class="ap-stat-icon ap-si-pricing"><fa-icon :icon="['fas', 'tags']" /></span>
        </div>
        <div class="ap-stat-wrapper">
          <div class="ap-stat-value">{{ pricing }}</div>
          <div class="ap-stat-value-label">pending tasks</div>
          <div class="ap-stat-foot">
            <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;opacity:0.4;font-size:10px" />
          </div>
        </div>
      </div>

      <div v-if="isSuperAdmin" class="ap-stat ap-stat--link" @click="$router.push({ name: 'Admin-User-Management', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">User Management</span>
          <span class="ap-stat-icon ap-si-admin-staff"><fa-icon :icon="['fas', 'users-cog']" /></span>
        </div>
        <div class="class ap-stat-wrapper">
          <div class="ap-stat-value ap-stat-value--icon">
            <fa-icon :icon="['fas', 'user-shield']" />
          </div>
          <div class="ap-stat-foot">
            <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;opacity:0.4;font-size:10px" />
          </div>
        </div>
      </div>

      <div class="ap-stat ap-stat--link" @click="$router.push({ name: 'Admin-New-Client', params: { lang: $route.params.lang } })">
        <div class="ap-stat-head">
          <span class="ap-stat-label">New Client</span>
          <span class="ap-stat-icon ap-si-client"><fa-icon :icon="['fas', 'user-plus']" /></span>
        </div>
        <div class="ap-stat-wrapper">
          <div class="ap-stat-value ap-stat-value--icon">
            <fa-icon :icon="['fas', 'id-card']" />
          </div>
          <div class="ap-stat-foot">
            <fa-icon :icon="['fas', 'chevron-right']" style="margin-left:auto;opacity:0.4;font-size:10px" />
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
export default {
  name: 'admin-task-widget',
  props: {
    tax: { type: Number, default: 0 },
    cosecAndBusinessSupport: { type: Number, default: 0 },
    incorporation: { type: Number, default: 0 },
    pricing: { type: Number, default: 0 },
    totalClients: { type: Number, default: 0 }
  },
  computed: {
    isSuperAdmin () {
      return localStorage.getItem('adminRole') === 'super_admin'
    }
  }
}
</script>
